import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';

const CalendarList = observer(class CalendarList extends React.Component {
  componentDidMount() {
    const { ScheduleStore } = this.props.store;

    ScheduleStore.getLocationCalendars(this.props.locationSid);
  }

  deleteCalendar(calendar) {
    const { ScheduleStore, SessionStore } = this.props.store;
    const { locationSid, sid } = calendar;
    const dialogContent = this.props.translation.delete_content

    SessionStore.showConfirm(dialogContent, () => ScheduleStore.deleteCalendar(locationSid, sid));
  }

  render() {
    const { translation } = this.props;
    const { ScheduleStore, SessionStore } = this.props.store;
    const { locationCalendars } = ScheduleStore;

    if(!SessionStore.loading) {
      return (
        <div className="panel--brief">
          <h2 className="panel__title">{translation.heading}</h2>

          {locationCalendars.length > 0 &&
            <ul className="calendar-list">
              {locationCalendars.map((calendar) =>
                <li key={calendar.sid} className="media--alt">
                  {calendar.title}

                  <div className="media__action">
                    <Link
                      to={`/locations/schedule/${this.props.locationSid}/view/${calendar.sid}`}
                      className="neutral"
                      onClick={() => this.props.setStep(3)}
                    >
                      <icons.iconCalendar />
                      <span className="meta">{translation.view}</span>
                    </Link>

                    <Link
                      to={`/locations/schedule/${this.props.locationSid}/calendar/${calendar.sid}`}
                      className="subdued"
                      onClick={() => this.props.setStep(2)}
                    >
                      <icons.iconGear />
                      <span className="meta">{translation.edit}</span>
                    </Link>

                    {/* We need more restrictions on this endpoint so that Calendars with
                        associated appointments aren't deleted
                    <button
                      className="btn--reset negative"
                      onClick={() => this.deleteCalendar(calendar)}
                    >
                      <icons.iconTrash />
                      <span className="meta">{translation.delete}</span>
                    </button> */}
                  </div>
                </li>
              )}
            </ul>
          }

          {locationCalendars.length === 0 &&
            <p>{translation.no_results}</p>
          }

          <div className='btn-group'>
            <button
              className='btn--outline'
              onClick={() => this.props.setStep(4)}
            >
              <icons.iconSettings />
              {translation.manage}
            </button>

            <button
              className="btn--outline"
              onClick={() => this.props.setStep(2)}
            >
              <icons.iconCalendarPlus />
              {translation.add_calendar}
            </button>
          </div>
        </div>
      )
    }

    return null;
  }
})

export default translate('CalendarList')(CalendarList);



// WEBPACK FOOTER //
// ./src/app/components/Schedule/CalendarList.js